/* eslint-disable import/no-anonymous-default-export */
import goal from './goal';

export default {
    goal,
}